/* istanbul ignore file */
import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components'
import { Box } from '@elparking/components'

const Icon = ({ theme, color, height }) => <Box height={height}>
    <svg style={{width: 'auto', height: '100%'}} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='16' cy='16' r='16' fill={theme.colors[color]}/>
        <circle cx='15.9998' cy='16.0003' r='13.3333' fill='white'/>
        <path d='M17.6018 11.0104V11M19.3335 11L17.6018 11M19.3335 21H17.6018C16.2712 21 15.0134 20.4803 14.0675 19.5343C13.1216 18.5884 12.6018 17.341 12.6018 16C12.6018 14.659 13.1216 13.4116 14.0675 12.4657C15.0134 11.5198 16.2712 11 17.6018 11M16.2162 14.2835H10.3622M16.2163 17.4115H10.3622' stroke={theme.colors[color]} strokeWidth='1.50356' strokeLinecap='round'/>
    </svg>
</Box>
Icon.propTypes = {
    theme: PropTypes.object,
    color: PropTypes.string,
    height: PropTypes.string,
}
Icon.defaultProps = {
    height: '24px',
}

export default withTheme(Icon)
